// 葡萄牙语
import pt from './JsonLang/pt.json'
import ptSpec from './JsonLangSpec/pt.json'
export const lang = {
  ...pt, ...ptSpec
}
